import { FC } from 'react';

import AddDraftInvestorModalHeader from './components/AddDraftInvestorModalHeader';
import AddDraftInvestorModalBody from './components/AddDraftInvestorModalBody';
import AddDraftInvestorModalFooter from './components/AddDraftInvestorModalFooter';
import { useAddDraftInvestorModal } from './context/AddDraftInvestorModalContext';

import CustomLoading from '../../CustomLoading';

import '../Modals.scss';

const AddDraftInvestorModal: FC = () => {
  const { data } = useAddDraftInvestorModal();

  return (
    <>
      <AddDraftInvestorModalHeader />
      <AddDraftInvestorModalBody />
      <AddDraftInvestorModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddDraftInvestorModal;
